import React, { useEffect, useRef, useState, useContext } from 'react';
import DownArrowIconDark from '/src/assets/down-arrow-icon-dark.svg';
import DownArrowIconLight from '/src/assets/down-arrow-icon-light.svg';
import UpArrowIconDark from '/src/assets/up-arrow-icon-dark.svg';
import UpArrowIconLight from '/src/assets/up-arrow-icon-light.svg';
import TabCard from '../TabCard/TabCard';
import { WindowSizeContext } from '/src/App';

import './style.css';

const NEWPropertyNavigationDesktop = ({
    tabs,
    activeTab,
    isContentLoaded,
    handleTabChange,
    // hoveredTab,
    // hoveredButton,
    // handleTabMouseEnter,
    // handleTabMouseLeave,
    // handleDropdownMouseEnter,
    // handleDropdownMouseLeave,
    // setActiveTab,
    // setHoveredTab,
    // setHoveredButton,
    // setIsInDropdown,
}) => {
    const { deviceType } = useContext(WindowSizeContext);
    const [isPinned, setIsPinned] = useState(false);
    const sentinelRef = useRef(null);
    const wrapperRef = useRef(null);

    // State for determining the margin bottom of the wrapper
    const [marginBottom, setMarginBottom] = useState('-30px');
    const [pageHeaderContainerHeightState, setPageHeaderContainerHeightState] = useState(0);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                setIsPinned(!entry.isIntersecting);
            },
            {
                threshold: 0
            }
        );

        if (sentinelRef.current) {
            observer.observe(sentinelRef.current);
        }

        return () => observer.disconnect();
    }, []);

    // State that monitors the device type and sets the margin bottom of the wrapper
    useEffect(() => {
        const pageHeaderContainer = document.querySelector('.page-header-container');
        const pageHeaderContainerHeight = pageHeaderContainer.offsetHeight;
        setPageHeaderContainerHeightState(pageHeaderContainerHeight);
       
        // if (deviceType === 'desktop' || deviceType === 'tablet') {
            
        //     const pageHeaderContainer = document.querySelector('.page-header-container');
        //     const pageHeaderContainerHeight = pageHeaderContainer.offsetHeight;
        //     setPageHeaderContainerHeightState(pageHeaderContainerHeight);
        //     console.log('pageHeaderContainerHeight', pageHeaderContainerHeight)
        //     setMarginBottom(`-${pageHeaderContainerHeight+30}px`);
        // } else if (deviceType === 'mobile') {
        //     setMarginBottom('0px');
        //     setPageHeaderContainerHeightState(0);
        // }
    }, [deviceType]);

    return (
        <>
            <div ref={sentinelRef} style={{ height: '0px', marginBottom: '-30px' }} />
            <div 
                ref={wrapperRef} 
                className={`property-explorer-section-nav-bar-desktop-wrapper ${isPinned ? 'pinned-to-top' : ''}`}
                style={{ top: pageHeaderContainerHeightState }}
            >
                <div className={`property-explorer-section-nav-bar-desktop ${deviceType}`}>
                    {/* Tabs row */}
                    {tabs.map(tab => {
                        // console.log('tab', tab)
                        return (
                            <TabCard
                                key={tab.id}
                                tab={tab}
                                activeTab={activeTab}
                                handleTabChange={isContentLoaded ? handleTabChange : null}
                            />
                        )
                    })}
                </div>
            </div>
        </>
    );
};

export default NEWPropertyNavigationDesktop;
